/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerNotificationsResponse as ModelsCustomerCustomerNotificationsResponse } from '../../models/Models/Customer/customer-notifications-response';

export interface V3CustomersMeNotificationsGet$Xml$Params {
  pageNumber?: number;
  pageSize?: number;
}

export function v3CustomersMeNotificationsGet$Xml(http: HttpClient, rootUrl: string, params?: V3CustomersMeNotificationsGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerNotificationsResponse>> {
  const rb = new RequestBuilder(rootUrl, v3CustomersMeNotificationsGet$Xml.PATH, 'get');
  if (params) {
    rb.query('pageNumber', params.pageNumber, {});
    rb.query('pageSize', params.pageSize, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsCustomerCustomerNotificationsResponse>;
    })
  );
}

v3CustomersMeNotificationsGet$Xml.PATH = '/v3/customers/me/notifications';
